import React, {ChangeEvent, useState} from 'react';
import Input from "./Input";

// Helpers ----

type TimeRange = {
  start: string
  end: string
  expression: string
}

function parseTimeRange(value?: Partial<TimeRange> | string | null): TimeRange {
  const timeRange: TimeRange = {start: '00:00', end: '23:59', expression: '00:00-23:59'}

  if(!value) {
    return timeRange
  }

  if (typeof value === 'string') {
    const [start, end] = value.split('-', 2)

    timeRange.start = start ?? timeRange.start
    timeRange.end = end ?? timeRange.end
  }

  if (typeof value === 'object') {
    timeRange.start = value.start ?? timeRange.start
    timeRange.end = value.end ?? timeRange.end
  }

  timeRange.expression = [timeRange.start, timeRange.end].join('-')

  return timeRange
}

// Component ----

type TimeRangePickerProps = {
  name: string
  value?: Partial<TimeRange> | string | null
  onChange: (value: TimeRange) => void
}

function TimeRangePicker({name, value, onChange}: TimeRangePickerProps) {

  const [range, setRange] = useState<TimeRange>(parseTimeRange(value));

  function handleChangeStart({currentTarget}: ChangeEvent<HTMLInputElement>) {
    const newStart = currentTarget.value
    const newRange = {start: newStart, end: range.end, expression: [newStart, range.end].join('-')}

    setRange(newRange)
    onChange(newRange)
  }

  function handleChangeEnd({currentTarget}: ChangeEvent<HTMLInputElement>) {
    const newEnd = currentTarget.value
    const newRange = {start: range.start, end: newEnd, expression: [range.start, newEnd].join('-')}

    setRange(newRange)
    onChange(newRange)
  }

  return (
    <div className="flex space-x-2 items-center">
      <Input
        name={`${name}-start`}
        type="time"
        pattern="[0-9]{2}:[0-9]{2}"
        min="00:00"
        max={range.end}
        value={range.start}
        onChange={handleChangeStart}
        required
      />

      <span>—</span>

      <Input
        name={`${name}-end`}
        type="time"
        pattern="[0-9]{2}:[0-9]{2}"
        min={range.start}
        max="23:59"
        value={range.end}
        onChange={handleChangeEnd}
        required
      />
    </div>
  );
}

export default TimeRangePicker;